/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ArchivedCatalog } from './ArchivedCatalog'
import {
  ArchivedCatalogFromJSON,
  ArchivedCatalogFromJSONTyped,
  ArchivedCatalogToJSON,
} from './ArchivedCatalog'

/**
 *
 * @export
 * @interface PaginatedCatalogArchivedAdmin
 */
export interface PaginatedCatalogArchivedAdmin {
  /**
   *
   * @type {ArchivedCatalog}
   * @memberof PaginatedCatalogArchivedAdmin
   */
  results: ArchivedCatalog
  /**
   *
   * @type {number}
   * @memberof PaginatedCatalogArchivedAdmin
   */
  count: number
  /**
   *
   * @type {string}
   * @memberof PaginatedCatalogArchivedAdmin
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedCatalogArchivedAdmin
   */
  previous: string | null
}

/**
 * Check if a given object implements the PaginatedCatalogArchivedAdmin interface.
 */
export function instanceOfPaginatedCatalogArchivedAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'results' in value
  isInstance = isInstance && 'count' in value
  isInstance = isInstance && 'next' in value
  isInstance = isInstance && 'previous' in value

  return isInstance
}

export function PaginatedCatalogArchivedAdminFromJSON(json: any): PaginatedCatalogArchivedAdmin {
  return PaginatedCatalogArchivedAdminFromJSONTyped(json, false)
}

export function PaginatedCatalogArchivedAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedCatalogArchivedAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    results: ArchivedCatalogFromJSON(json['results']),
    count: json['count'],
    next: json['next'],
    previous: json['previous'],
  }
}

export function PaginatedCatalogArchivedAdminToJSON(
  value?: PaginatedCatalogArchivedAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    results: ArchivedCatalogToJSON(value.results),
    count: value.count,
    next: value.next,
    previous: value.previous,
  }
}
